import React from 'react';
import { Route } from 'react-router-dom';
import { AllRouteConstants } from '../../../router/routes';
import { WithdrawFund, WithdrawLog } from '../pages';
import { useAppSelector } from '../../../hooks/useAppSelector';
import Redirect from '../../../HoC/Redirect';

const WithdrawRoutes = () => {
	const { mode } = useAppSelector((state) => state.cachedReducer);

	return mode === 'real' ? (
		<>
			<Route
				path={AllRouteConstants.user.withdraw_fund}
				element={<WithdrawFund />}
			/>
			<Route
				path={AllRouteConstants.user.withdraw_history}
				element={<WithdrawLog />}
			/>
		</>
	) : (
		<>
			<Route
				path={AllRouteConstants.user.withdraw_fund}
				element={<Redirect path={AllRouteConstants.user.home} />}
			/>
			<Route
				path={AllRouteConstants.user.withdraw_history}
				element={<Redirect path={AllRouteConstants.user.home} />}
			/>
		</>
	);
};

export default WithdrawRoutes;
